module.exports = __webpack_public_path__ + "static/media/pic_sy.9de6147b.png";